module.exports = __webpack_public_path__ + "static/media/requirements-icon--white.fc3a3b2f.svg";